import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { userService } from "../services/userService";
import Utils from "../utils/Utils";
import { translateLabel, useTranslationSnapshot } from "./../translations/runtime";


const PENDING_APPROVAL_TOAST_ID = "vendor-pending-approval";

const getStoredJwt = () => {
  const storedUser = userService.getJwt();

  if (typeof storedUser === "string") return storedUser;

  return (
    storedUser?.jwt ||
    storedUser?.token ||
    storedUser?.accessToken ||
    storedUser?.access_token ||
    ""
  );
};

const isJwtPendingApproval = (jwt) => {
  const decodedJwt = jwt ? Utils.parseJwt(jwt) || null : null;

  return decodedJwt?.isActive === false;
};

function VendorApprovalStatusBanner() {
  useTranslationSnapshot();
  const [isPendingApproval, setIsPendingApproval] = useState(() =>
    isJwtPendingApproval(getStoredJwt()),
  );

  useEffect(() => {
    const syncApprovalStatus = (event) => {
      setIsPendingApproval(
        isJwtPendingApproval(event?.detail?.jwt || getStoredJwt()),
      );
    };

    window.addEventListener("user-session-updated", syncApprovalStatus);
    window.addEventListener("storage", syncApprovalStatus);

    syncApprovalStatus();

    return () => {
      window.removeEventListener("user-session-updated", syncApprovalStatus);
      window.removeEventListener("storage", syncApprovalStatus);
    };
  }, []);

  useEffect(() => {
    if (isPendingApproval) {
      if (!toast.isActive(PENDING_APPROVAL_TOAST_ID)) {
        toast.info(
          translateLabel("txt_web_vendor_your_account_is_pending_approval_you_can_continue_using_the_system_normally", "Your account is pending approval. You can continue using the system normally."),
          {
            toastId: PENDING_APPROVAL_TOAST_ID,
            autoClose: false,
            closeOnClick: false,
          },
        );
      }

      return;
    }

    toast.dismiss(PENDING_APPROVAL_TOAST_ID);
  }, [isPendingApproval]);

  return null;
}

export default VendorApprovalStatusBanner;
